export const Photos =
    [
        {
            id: 0,
            name: 'D_504.jpg',
            size: '283 Ko',
            type: 'Image JPG',
            date: '26/04/2005 20:40',
            selected: false,
            path: require('../img/photos/chien.png')
        },
        {
            id: 1,
            name: 'citation.png',
            size: '43 Ko',
            type: 'Image PNG',
            date: '14/02/2005 22:12',
            selected: false,
            path: require('../img/photos/citation.png')
        },
        {
            id: 2,
            name: 'vac-1.jpg',
            size: '20 Ko',
            type: 'Image JPG',
            date: '17/08/2004 17:04',
            selected: false,
            path: require('../img/photos/vacance1.jpg')
        },
        {
            id: 3,
            name: 'vac-2.jpg',
            size: '23 Ko',
            type: 'Image JPG',
            date: '17/08/2004 17:04',
            selected: false,
            path: require('../img/photos/vacance2.jpg')
        },
        {
            id: 4,
            name: 'vac-3.png',
            size: '527 Ko',
            type: 'Image PNG',
            date: '17/08/2004 17:04',
            selected: false,
            path: require('../img/photos/vacance3.png')
        },
        {
            id: 5,
            name: 'vac-4.jpg',
            size: '80 Ko',
            type: 'Image JPG',
            date: '17/08/2004 17:04',
            selected: false,
            path: require('../img/photos/vacance4.jpg')
        },
        {
            id: 6,
            name: 'vac-5.jpg',
            size: '107 Ko',
            type: 'Image JPG',
            date: '17/08/2004 17:04',
            selected: false,
            path: require('../img/photos/vacance5.jpg')
        },
        {
            id: 7,
            name: 'anniv-1.jpg',
            size: '123 Ko',
            type: 'Image JPG',
            date: '11/03/2003 14:19',
            selected: false,
            path: require('../img/photos/anniversaire1.png')
        },
        {
            id: 8,
            name: 'anniv-2.jpg',
            size: '568 Ko',
            type: 'Image JPG',
            date: '11/03/2003 14:19',
            selected: false,
            path: require('../img/photos/anniversaire2.jpg')
        },
        {
            id: 9,
            name: 'anniv-3.jpg',
            size: '18 Ko',
            type: 'Image JPG',
            date: '11/03/2003 14:19',
            selected: false,
            path: require('../img/photos/anniversaire3.jpg')
        }
    ]